const getSessionJWT = (): string | undefined => {
  const cookie = document.cookie.split('; ').find((row) => row.startsWith(`intermediate_session_token`))?.split('=')[1]

  const data = {session_jwt: cookie}
  return data.session_jwt || " ";
};

export { getSessionJWT };